import { css, Stack, styled } from '@mui/material';

export const SContainer = styled(Stack)(
  ({ theme }) => css`
    ${theme.breakpoints.up('tablet')} {
      gap: 16px;
    }
  `,
);
